import type {AxiosRequestConfig} from 'axios';
import {City} from './interface';

export class DeleteCityBuilder {
  private readonly citiesRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };
  id(id: number) {
    this.citiesRequest.url = `/cities/${id}`;
    return this;
  }
  build() {
    return this.citiesRequest;
  }
}
export class GetAllCitiesRequestBuilder {
  private readonly citiesRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/cities',
    params: {},
  };

  id(id: number) {
    this.citiesRequest.url = `/cities/${id}`;
    return this;
  }

  params(params: object) {
    this.citiesRequest.params = params;
    return this;
  }

  build() {
    return this.citiesRequest;
  }
}
export class GetCitiesCountRequestBuilder {
  private readonly citiesRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/cities/count',
  };

  params(params: object) {
    this.citiesRequest.params = params;
    return this;
  }

  build() {
    return this.citiesRequest;
  }
}

export class CreateCityRequestBuilder {
  private readonly citiesRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/cities',
    data: {},
  };

  data(data: City) {
    this.citiesRequest.data = data;
    return this;
  }

  build() {
    return this.citiesRequest;
  }
}

export class UpdateCityRequestBuilder {
  private readonly citiesRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/cities',
    data: {},
  };
  data(body: City) {
    this.citiesRequest.data = body;
    return this;
  }
  build() {
    return this.citiesRequest;
  }
}

export class UpdateCityStatusRequestBuilder {
  private readonly citiesRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/cities',
    data: {},
  };
  id(id: number) {
    this.citiesRequest.url = `/cities/${id}/status`;
    return this;
  }
  data(body: City) {
    this.citiesRequest.data = body;
    return this;
  }
  build() {
    return this.citiesRequest;
  }
}
